var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2B43DA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.36 15.6494V13.0094H8V11.0094H18.36V8.36937L22 12.0094L18.36 15.6494ZM17.58 18.4594C18.02 18.0194 18.02 17.3094 17.58 16.8694C17.14 16.4294 16.43 16.4294 15.99 16.8694C13.31 19.5494 8.95 19.5494 6.27 16.8694C3.59 14.1894 3.59 9.82937 6.27 7.14937C8.95 4.46937 13.31 4.46937 15.99 7.14937C16.43 7.58937 17.14 7.58937 17.58 7.14937C18.02 6.70937 18.02 5.99937 17.58 5.55937C14.01 1.98937 8.23 1.98937 4.67 5.54937C1.11 9.10937 1.11 14.8894 4.67 18.4494C6.45 20.2294 8.79 21.1194 11.12 21.1194C13.45 21.1194 15.79 20.2294 17.57 18.4494L17.58 18.4594Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8a3ba06080a28b906aab67cb90920546.svg";
export { ForwardRef as ReactComponent };